module.exports = "<ea-profile-page user-has-demo-feature=\"$ctrl.userHasDemoFeature\"\n                 user-is-demo-user=\"$ctrl.userIsDemoUser\"\n                 type=\"$ctrl.type\">\n</ea-profile-page>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/eaSettings/eaProfile/eaProfilePage/eaProfilePageModule.html
// module id = 496
// module chunks = 12